import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent, Typography, List } from "@material-ui/core";
import {
  CheckStatusIcon,
  InlineLink,
  DetailedListItem,
  DetailedListItemTitle,
} from "/lib/component/base";

const ActiveAlertsCard = ({ entity, namespace }) => {
  const [alerts, setAlerts] = useState([]);

  const headers = {
    'Authorization': 'GenieKey 7c81aff1-8224-4bbd-a65f-ccdd17e7f45a',
    'Content-Type': 'application/json; charset=UTF-8',
  }

  useEffect(() => {
    const fetchAlerts = () => {
      axios.get("https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/opsgenie", {
        params: {
          query: `status:open AND tag:${namespace} AND tag:${entity.name}`,
        },
        headers
      })
      .then((response) => {
        // Assuming the API returns an array of alerts in the response.data
        setAlerts(response.data.data); // Adjust according to the actual response structure
        console.log(response.data.data)
      })
      .catch((error) => {
        console.error("Error fetching alerts:", error);
      });
    };

    fetchAlerts();
  }, []);

  const renderAlert = (alert) => {
    // Adjust the link and fields according to your needs and OpsGenie's response structure
    const link = `https://bmkrs.app.opsgenie.com/alert/detail/${alert.id}/details`;

    return (
      <DetailedListItem key={alert.id}>
        <DetailedListItemTitle inset>
          <Typography
            component="span"
            style={{ position: "absolute", left: 0 }}
          >
            <CheckStatusIcon statusCode={1} inline mutedOK small />
          </Typography>
          <a
            href={link}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {alert.message} {/* Adjust if necessary */}
          </a>
        </DetailedListItemTitle>
      </DetailedListItem>
    );
  };

  const renderAlerts = () => {
    return alerts.map(renderAlert);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" paragraph>
          OpsGenie Alerts
        </Typography>
        <List disablePadding>{renderAlerts()}</List>
      </CardContent>
    </Card>
  );
};

export default ActiveAlertsCard;
